import axios from 'axios'
import API from './API.js'

export default class Settings extends API {
  constructor() {
    super('setting')
  }
  async GetAll(params) {
    // console.log("api", params);
    try {
      const response = await axios.get(`/${this.route}`, { params })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async time(params) {
    try {
      const response = await axios.get(`time`, { params })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
  async addNewRoutes(data, headers) {
    try {
      const response = await axios.post(`/add-new-routes`, data, headers)
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }


}
